export default "__VITE_ASSET__CiESUlVJ__"